var _rect, _rect2, _path, _rect3, _rect4, _path2, _rect5, _rect6, _path3, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.62125,
    y: 13.3135,
    width: 16,
    height: 46,
    transform: "rotate(-45 2.62125 13.3135)",
    fill: "#CED2DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51038 17.2021L13.5814 10.1311L15.7028 12.2524L8.6317 19.3235L6.51038 17.2021Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8137,
    y: 22.5059,
    width: 10,
    height: 3,
    transform: "rotate(-45 11.8137 22.5059)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8346,
    y: 34.5264,
    width: 10,
    height: 3,
    transform: "rotate(-45 23.8346 34.5264)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1378 39.8301L36.2089 32.759L38.3302 34.8803L31.2591 41.9514L29.1378 39.8301Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.98535,
    y: 29.5771,
    width: 30,
    height: 14,
    transform: "rotate(-45 8.98535 29.5771)",
    fill: "#304FF2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9351,
    y: 24.627,
    width: 16,
    height: 14,
    transform: "rotate(-45 13.9351 24.627)",
    fill: "#101114"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21231 41.7748L8.98528 29.5772L18.8848 39.4767L6.68718 44.2497L4.21231 41.7748Z",
    fill: "#304FF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6127,
    y: 6.94922,
    width: 6,
    height: 14,
    transform: "rotate(-45 31.6127 6.94922)",
    fill: "#304FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibility);
export default __webpack_public_path__ + "static/media/flexibility.4026e0abda4a988cee2471c549dd8252.svg";
export { ForwardRef as ReactComponent };